var chunkToChildrenMap = {"8074":["3831"],"1591":["3831"],"8783":["3831"],"9626":["3831"],"3606":["3831"],"4585":["3831"],"4118":["3831"],"9102":["3831"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};